// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
        let status = await store
        .getState()
        .blockchain.smartContract.methods.paused()
        .call();
      let cost = await store
        .getState()
        .blockchain.smartContract.methods.walletOfOwner(web3.currentProvider.selectedAddress)
        .call();
        let i=1;
        let ur = [];
        for(let i = 1; i < cost.length; i++){
        let k = await store
        .getState()
        .blockchain.smartContract.methods.tokenURI(cost[i])
        .call();
         ur.push(k);
        }
      dispatch(
        fetchDataSuccess({
          totalSupply,
          status,
          cost,
          ur
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
